require("./src/index.css");
const React = require("react")
const Layout = require("./src/components/App").default;
const Comlink = require("comlink/dist/esm/comlink.mjs");


exports.registerServiceWorker = () => true;


async function initComlink() {
  await navigator.serviceWorker.ready;
  const { port1, port2 } = new MessageChannel();
  const msg = {
    comlinkInit: true,
    port: port1
  };

  const controller = await new Promise(res => {
    if(navigator.serviceWorker.controller) {
      return res(navigator.serviceWorker.controller);
    }
    const onControllerChange = () => {
      if(navigator.serviceWorker.controller) {
        navigator.serviceWorker.removeEventListener("controllerchange", onControllerChange)
        return res(navigator.serviceWorker.controller);
      }
    };
    return navigator.serviceWorker.addEventListener("controllerchange", onControllerChange);
  });
  controller.postMessage(msg, [port1]);

  const swProxy = Comlink.wrap(port2);
  console.log(await swProxy.counter);
  await swProxy.inc();
  console.log(await swProxy.counter);
}

exports.wrapPageElement = ({ element, props }) => {
  initComlink();
  // props provide same data to Layout as Page element will get
  // including location, data, etc - you don't need to pass it
  return <Layout {...props}>{element}</Layout>
}
